import { Badge } from '@chakra-ui/react';
import { LessonStatus } from '@opanuj/shared/types';

type CardStatusProps = {
	status: LessonStatus;
	hasRescheduleOptions: boolean;
};

const CardStatus = ({ status, hasRescheduleOptions }: CardStatusProps) => {
	switch (status) {
		case LessonStatus.Regular:
			return (
                <Badge m={1} colorPalette="green">Regularne
                                    </Badge>
            );
		case LessonStatus.Cancelled:
			if (hasRescheduleOptions) {
				return (
                    <Badge m={1} colorPalette="yellow">Termin odrabiania oczekuje na potwierdzenie
                                            </Badge>
                );
			} else {
				return (
                    <Badge m={1} colorPalette="orange">Odwołane
                                            </Badge>
                );
			}
		case LessonStatus.Rescheduled:
			return (
                <Badge m={1} colorPalette="blue">Przełożone
                                    </Badge>
            );
		case LessonStatus.Extra:
			return (
                <Badge m={1} colorPalette="blue">Odrabiane
                                    </Badge>
            );
		default:
			return null;
	}
};
export default CardStatus;